import { useState } from "react";
import { useSelector } from "react-redux";
import { ClipControls } from "../../parameterWidgets/ClipControls";
import { SelectorSonsLooper } from "../../parameterWidgets/SelectorSonsLLibreria";
import { GrufModulEQ, GrufModulSends } from "../../components/moduls";
import { ParameterKnob } from "../../parameterWidgets/ParameterKnob";
import SeparatorLine from "jsx:$assets/widgets/separator_line.svg";
import { ParameterDropdown } from "../../parameterWidgets/ParameterDropdown";
import { ParameterToggle } from "../../parameterWidgets/ParameterToggle";
import { ParameterSlider } from "../../parameterWidgets/ParameterSlider";
import { LooperWaveform } from "../../components/Waveform";
import { HelpBox } from "../../components/HelpBox";
import { PresetBankBar } from "../../parameterWidgets/PresetBankBar";

export const LooperUI = ({instrument}) => {
    return (
        <div className="estacio estacio-looper" style={{"--accent-color": instrument.metadata.color}}>
            <PresetBankBar instrument={instrument} className="col-span-2" />
            <div className="col-span-3"></div>

            <div className="modul-border modul-bg flex justify-between col-span-2 items-center">
                <ParameterKnob data-widget-id="instrumentVolume" mida="gran" parameterHandler={instrument.getParameterHandler("gain")} />
                <SeparatorLine className="h-full"/>
                <ParameterKnob data-widget-id="lpfCutoff" mida="gran" parameterHandler={instrument.getParameterHandler("lpf_cutoff")} />
            </div>
    
            <GrufModulEQ instrument={instrument} />
            <GrufModulSends instrument={instrument} />
            <HelpBox instrument={instrument} />

            <fieldset className="modul-border flex flex-col justify-around items-center gap-10">
                <ParameterSlider data-widget-id="looperTranspose" orientation="vertical" parameterHandler={instrument.getParameterHandler("transpose")} />
                <ParameterKnob data-widget-id="looperSpeed" mida="gran" knobSize="50px" parameterHandler={instrument.getParameterHandler("speed")} sideEffect={() => instrument.adjustClipLengthToFit()} />
                <ParameterToggle data-widget-id="looperReverse" parameterHandler={instrument.getParameterHandler("isReverse")} />
            </fieldset>

            <div className="col-span-4 relative" style={{minHeight: 0}}>  {/* minHeight 0 to prevent grid item from expanding due to responsivecanvas*/}
                <LooperWaveform instrument={instrument} className="h-full"/>
                <SelectorSonsLooper instrument={instrument} className="absolute" style={{top: 15, left: 15}}/>
            </div>

            <ClipControls className="col-span-full justify-self-end" instrument={instrument} hideLengthControls />
        </div>
    )
};